import { NgModule } from '@angular/core';
import {
  TreatmentFeedbackSummaryDataServiceAdapter
} from './impl/services/ngrx/treatment-feedback-summary.data.service.adapter';
import {TreatmentFeedbackDataServiceAdapter} from './impl/services/ngrx/treatment-feedback.data.service.adapter';
import {TreatmentFeedbackDataService} from './impl/services/ngrx/treatment-feedback.data.service';
import {TreatmentFeedbackRepository} from './impl/services/ngrx/treatment-feedback.repository';
import {TreatmentFeedbackConverter} from './api/models/converter/treatment-feedback.converter';
import {TreatmentFeedbackSummaryConverter} from './api/models/converter/treatment-feedback.summary.converter';
import {EntityDataService, EntityServices} from '@ngrx/data';



@NgModule({
  providers: [

    TreatmentFeedbackSummaryDataServiceAdapter,
    TreatmentFeedbackDataServiceAdapter,
    TreatmentFeedbackDataService,
    TreatmentFeedbackRepository,
    TreatmentFeedbackConverter,
    TreatmentFeedbackSummaryConverter,

  ],
})
export class TreatmentFeedbackModule {
  constructor(
      entityDataService: EntityDataService,
      entityServices: EntityServices,
      dataService: TreatmentFeedbackDataService,
      service: TreatmentFeedbackRepository,
  ) {

    entityDataService.registerServices({
      TreatmentFeedback: dataService,
    });

    entityServices.registerEntityCollectionServices({
      TreatmentFeedback: service,
    });
  }
}
